import { UserPermission } from '../../data/models/permission.model';
import { useAppSelector } from '../useAppSelector';
import * as userSlice from '../../data/user.slice';
import { useHasPermission } from './useHasPermission';

export const useCanReadReservationDetails = (): boolean => {
  const user = useAppSelector(userSlice.selectLoggedInUserInfo);

  const readPermissionTripInventory: UserPermission = {
    resource: 'tripinventory',
    action: 'readbasic',
    scope: 'all',
  };

  const readPermissionPassengers: UserPermission = {
    resource: 'passengers',
    action: 'readbasic',
    scope: 'all',
  };

  const canReadTripInventory = useHasPermission(
    user,
    readPermissionTripInventory,
  );
  const canReadPassengers = useHasPermission(user, readPermissionPassengers);
  return canReadTripInventory || canReadPassengers;
};
